__turbopack_context__.v({
  "errorContainer": "error-module__kLpliG__errorContainer",
  "icon": "error-module__kLpliG__icon",
  "message": "error-module__kLpliG__message",
  "refreshButton": "error-module__kLpliG__refreshButton",
});
